import orderReducer, {
  cancellationCartApi,
  cartApi,
  dedicatedChannelsCartApi,
  orderApi,
  sharedChannelsCartApi,
} from '@reducers/order/order';
import { didServiceTypeApi } from '@reducers/order/serviceType';

export { didServiceTypeApi } from '@reducers/order/serviceType';
export { cartApi } from '@reducers/order/order';
export { cancellationCartApi } from '@reducers/order/order';
export { dedicatedChannelsCartApi } from '@reducers/order/order';
export { sharedChannelsCartApi } from '@reducers/order/order';
export { orderApi } from '@reducers/order/order';

export const orderMiddlewares = [
  cartApi.middleware,
  cancellationCartApi.middleware,
  dedicatedChannelsCartApi.middleware,
  sharedChannelsCartApi.middleware,
  didServiceTypeApi.middleware,
  orderApi.middleware,
];
export const orderReducers = {
  order: orderReducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [cancellationCartApi.reducerPath]: cancellationCartApi.reducer,
  [dedicatedChannelsCartApi.reducerPath]: dedicatedChannelsCartApi.reducer,
  [sharedChannelsCartApi.reducerPath]: sharedChannelsCartApi.reducer,
  [didServiceTypeApi.reducerPath]: didServiceTypeApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
};
